import React from "react";
import { string, bool } from "prop-types";
import "./tag-representation-card.m.css";

/**
 * TagRepresentationCard component displays tag information in the first position
 * Features:
 * - Tag name in brand color background
 * - Tag description below
 * - Matches Figma design for tag landing pages
 */
export const TagRepresentationCard = ({ tagName, tagDescription, brandColor, isMobile }) => {
  if (!tagName) return null;

  return (
    <div styleName="tag-representation-card">
      {/* Top Section - Tag Name with Brand Color Background */}
      <div styleName="tag-card-header" style={{ backgroundColor: brandColor }}>
        <div styleName="tag-card-title">
          <p>{tagName}</p>
        </div>
      </div>

      {/* Bottom Section - Tag Description */}
        <div styleName="tag-card-content">
          {tagDescription &&
          <div styleName="tag-card-description">
            <p styleName={`tag-desc ${isMobile ? 'line-clamp-3' : 'line-clamp-6'}`}>{tagDescription}</p>
          </div>}
        </div>

    </div>
  );
};

TagRepresentationCard.propTypes = {
  tagName: string.isRequired,
  tagDescription: string,
  brandColor: string,
  isMobile: bool,
};

TagRepresentationCard.defaultProps = {
  brandColor: "#FF2626",
};
